import React from 'react';
import { TagOutlined } from '@ant-design/icons';

export const ADD_LABEL_CHIP_BASE_CLASS =
	'footnoteregular box-border h-[30px] cursor-pointer items-center gap-1 rounded-full border border-solid !border-grey-5 bg-white px-2 py-1 text-grey-10 hover:bg-grey-2';

export const ADD_LABEL_CHIP_ICON_CLASS =
	'inline-flex h-3 w-3 shrink-0 items-center justify-center text-[12px] leading-none';

interface Props {
	onClick: (event: React.MouseEvent) => void;
	/** Controls the chip's own display utility. Defaults to always-visible; pass a row's
	 * reveal-on-hover classes (e.g. "hidden group-hover:inline-flex") to hide the chip
	 * until an ancestor `.group` is hovered. */
	displayClassName?: string;
	disabled?: boolean;
}

/** Shared "+"-with-tag-icon pill for triggering "add labels" — used on work order rows, the WO detail header, and parts rows. */
const AddLabelChip: React.FC<Props> = ({
	onClick,
	displayClassName = 'inline-flex',
	disabled = false,
}) => {
	const handleKeyDown = (event: React.KeyboardEvent) => {
		if (disabled) return;
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			onClick(event as unknown as React.MouseEvent);
		}
	};

	return (
		<span
			role="button"
			tabIndex={disabled ? -1 : 0}
			onClick={onClick}
			onKeyDown={handleKeyDown}
			className={`${displayClassName} ${ADD_LABEL_CHIP_BASE_CLASS}${
				disabled ? ' pointer-events-none opacity-50' : ''
			}`}
		>
			<span>+</span>
			<TagOutlined size={12} className={ADD_LABEL_CHIP_ICON_CLASS} />
		</span>
	);
};

export default AddLabelChip;
